import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * `.panel` — the mockup's boxed section:
 *   .panel   { background:surface; border:1px line; border-radius:18px }
 *   .panel-h { padding:16px 20px; border-bottom:1px line; space-between }
 *   .panel-h h3 { font-size:15px; font-weight:700; icon gap 9px }
 *   .panel-b { padding:8px 20px }
 *
 * Presentation only. `bodySx` exists because a few panels in the mockup
 * override `.panel-b`'s padding inline (attendance table, homework card).
 */
const TeacherPanel = ({ title, subtitle, action, icon, children, sx = {}, bodySx = {} }) => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: '18px',
      overflow: 'hidden',
      ...sx,
    }}
  >
    {(title || subtitle || action) && (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1.5,
          padding: '16px 20px',
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '9px', minWidth: 0 }}>
          {icon && (
            <Box
              sx={{
                display: 'grid',
                placeItems: 'center',
                color: 'primary.main',
                '& svg': { fontSize: 18 },
              }}
            >
              {icon}
            </Box>
          )}
          <Typography
            component="h3"
            sx={{ fontSize: '15px', fontWeight: 700, color: 'text.primary' }}
          >
            {title}
          </Typography>
        </Box>

        {action ||
          (subtitle && (
            <Typography sx={{ fontSize: '12.5px', color: 'text.secondary', flex: 'none' }}>
              {subtitle}
            </Typography>
          ))}
      </Box>
    )}

    <Box sx={{ padding: '8px 20px', ...bodySx }}>{children}</Box>
  </Box>
);

export default TeacherPanel;
